// @flow

import { Component } from '../jsti/core';
import Template from '../classes/Template';
import EventNames from '../constants/EventNames';
import Notifications from '../constants/Notifications';

export default class Disclaimer extends Component {
  #acceptHandler: function;
  confirmButton: ?HTMLElement;

  /**
   * Instantiate the component
   */
  bind(el: HTMLElement): void {
    super.bind(el);

    if (!(this.el.dataset.render === 'true')) return;

    this.render();
    this.setUp();

    this.#acceptHandler = this.accept.bind(this);

    if (!this.confirmButton) return;
    this.confirmButton.addEventListener(EventNames.CLICK, this.#acceptHandler);
  }

  /**
   * Render the disclaimer
   */
  render(): void {
    this.el.appendChild(Template.getContent(this.el.firstElementChild));
    if (this.el.firstElementChild) {
      this.el.removeChild(this.el.firstElementChild);
    }
  }

  /**
   * Validate the rendered HTML and set the necessary properties
   */
  setUp(): void {
    this.confirmButton = this.el.getElementByRef('confirm-button');
  }

  /**
   * Accept the disclaimer
   */
  accept(): void {
    this.notify(Notifications.ACCEPT_DISCLAIMER);

    if (!this.el.firstElementChild) return;
    this.notify(Notifications.TOGGLE_MODAL, { id: this.el.firstElementChild.id });
  }

  /**
   * Destroy all event listeners
   */
  destroy(): void {
    super.destroy();
    if (!this.confirmButton) return;
    this.confirmButton.removeEventListener(EventNames.CLICK, this.#acceptHandler);
  }
}
